import store from '../state'
import router from '../router'
import { toastController } from '@modus/ionic-vue'

export function handleUnauthenticatedError(error) {
  if(!error.config) {
    return Promise.reject(error)
  }

  // don't handle login from here
  if(error.config.url.endsWith('/oauth/token')) {
    return Promise.reject(error)
  }

  if(!error.response) {
    return Promise.reject(error)
  }

  if(error.response.status !== 401) {
    return Promise.reject(error)
  }

  toastController.create({
    message: 'Unauthenticated. Attempting to re-authenticate.',
    duration: 3000
  })
  .then(toast => toast.present())

  // authenticate then refresh page
  store.dispatch('refresh')
    .then(() => location.reload())
    .catch(e => {
      console.error(e)
      returnToLogin()
    })
}

function returnToLogin() {
  toastController.create({
    message: 'Authentication failed, please sign back in.',
    duration: 3000
  })
  .then(toast => toast.present())

  store.dispatch('logout')
    .then(() => router.push({ name: 'login' }))
}
